import React, { Fragment, useContext, useMemo } from "react"
import { useStaticQuery, graphql } from "gatsby"
import FlexTable, { FlexTableCell } from "../flex-table"
import Link from "../link"
import CheckThickIcon from "../../icons/check-thick"
import { UserInterfaceContext } from "../../context/UserInterfaceContext"
import classNames from "../../utils/classnames"
import GcStartFilter from "../gc-start-filter"
import FancyImage from "../fancy-image"
import GridIcon from "../../icons/grid"
import ListIcon from "../../icons/list"
import { campusUrlFromName } from "../../utils/georgian"
import isBrowser from "../../utils/isBrowser"
import CloseThickIcon from "../../icons/close-thick"
import GcCampusFilter from "../gc-campus-filter"
import GcAreaFilter from "../gc-area-filter"
import GcKeywordFilter from "../gc-keyword-filter"
import GcDeliveryFilter from "../gc-delivery-filter"
import GcCredentialFilter from "../gc-credential-filter"
import StarIconComponent from "../star-icon"

export default function ProgramListingFavoriteIcons(props): JSX.Element {
  // console.log(`ProgramListingBlock`, props)
  const { partTimeOnly } = props
  const debug = isBrowser
    ? window.localStorage.getItem(`gcdebug`) === `true`
    : false
  const programListQuery: Queries.GcProgramListQuery = useStaticQuery(graphql`
    query GcProgramList {
      allGcProgram(filter: { showInList: { eq: true }, hasOverridingProgram: { eq: false } }) {
        totalCount
        nodes {
          title
          programCode
          dataSource
          catalogProgram {
            customFieldsJson
          }
          sourceProgram {
            ... on CimcatProgram {
              locations
              coop
              delivery
              credential
              academicarea
              academicArea
              intakes {
                year
                semester
                suspended
                campuses {
                  name
                  url
                }
              }
						}
            ... on D1Certificate {
              id
              credential: category
            }
            ... on PtsProgram {
              Campuses
              credential: Credential
            }
          }
        }
      }
      nonBannerPrograms: allWpOldProgram(
        filter: { customFieldsJson: { regex: "/non_banner\":true/" } }
      ) {
        nodes {
          title
          customFieldsJson
          featuredImageSrc
          featuredImageAlt
        }
      }
    }
  `)

  const programs = programListQuery?.allGcProgram?.nodes
  let hasFavorites = false
  hasFavorites =
    isBrowser &&
    programs.some(
      program =>
        localStorage.getItem(
          `favoriteGeorgianProgram_${program.programCode}`
        ) === `true`
    )

  return hasFavorites ? (
    <svg
      width="24"
      height="30"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 2C5.44772 2 5 2.44772 5 3V21C5 21.5523 5.44772 22 6 22C6.27614 22 6.55229 21.8946 6.77639 21.6831L12 16.8472L17.2236 21.6831C17.4477 21.8946 17.7239 22 18 22C18.5523 22 19 21.5523 19 21V3C19 2.44772 18.5523 2 18 2H6Z"
        fill="none"
        stroke="black"
        strokeWidth="2"
      />
      <circle cx="18" cy="3" r="5" fill="rgb(81, 131, 14)"></circle>
    </svg>
  ) : (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 2C5.44772 2 5 2.44772 5 3V21C5 21.5523 5.44772 22 6 22C6.27614 22 6.55229 21.8946 6.77639 21.6831L12 16.8472L17.2236 21.6831C17.4477 21.8946 17.7239 22 18 22C18.5523 22 19 21.5523 19 21V3C19 2.44772 18.5523 2 18 2H6Z"
        stroke="black"
        strokeWidth="2"
        fill="none"
      />
    </svg>
  )
}
